import request from '@/utils/request'

export function list(id) {


  return request({
    url: '/departments/' + id,
    method: 'get',
  })
}

export function add(departments) {
  const data = Object.assign({},departments)
  return request({
    url: '/department/add',
    method: 'post',
    data
  })
}

export function updatedep(departments) {

  const data = departments
  return request({
    url: 'department/update/' + departments.id,
    method: 'post',
    data
  })
}
export function show(id) {

  return request({
    url: '/department/' + id,
    method: 'get',
    id
  })
}

export function departmentDetails(id) {
  return request({
    url: '/time-selection/' + id,
    method: 'get',
  })
}

export function deleteDepartment(departments) {
  const data = {
    id: departments.id,
    department_name: departments.department_name,
    description: departments.description,
    company_id: departments.company_id,
    booking_message: departments.booking_message,

  }
  return request({
    url: '/department/' + departments.id,
    method: 'post',
    data
  })
}

export function getDaySlots(data) {
  return request({
    url: '/get-slots/' + data.id + '/' + data.day,
    method: 'post',
    data
  })
}

export function getCompanyDetails($data) {
  return request({
    url: 'department-selection/' + $data,
    method: 'get',
  })
}

export function departmentDetailsBySlug(data) {
  return request({
    url: `/time-selection-slug/${data.staffSlug}/${data.company_slug}`,
    method: 'get',
  })
}
